"use client";

import { cn } from "@/lib/utils";
import { AnimatePresence } from "motion/react";
import { useTheme } from "next-themes";
import { useEffect, useMemo, useState } from "react";

interface VideoEmbedProps {
	lightVideo: string;
	darkVideo: string;
	className?: string;
}

export const VideoEmbed = ({
	lightVideo,
	darkVideo,
	className,
}: VideoEmbedProps) => {
	const theme = useTheme();

	const videoSrc = useMemo(
		() => (theme.resolvedTheme === "dark" ? darkVideo : lightVideo),
		[theme.resolvedTheme, darkVideo, lightVideo],
	);
	const [isThemeLoading, setIsThemeLoading] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => setIsThemeLoading(false), 100);
		return () => clearTimeout(timer);
	}, []);

	if (isThemeLoading) {
		return null;
	}

	return (
		<AnimatePresence>
			<video
				key={videoSrc}
				width="100%"
				height="100%"
				autoPlay
				loop
				muted
				playsInline
				className={cn("transition-all", className)}
			>
				<source src={videoSrc} type="video/mp4" />
				<source src={videoSrc.replace(".mp4", ".webm")} type="video/webm" />
			</video>
		</AnimatePresence>
	);
};
